import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import pic1 from '../../images/icon.webp'
import pic2 from '../../images/CONFERENCE-ROOM.webp'
import pic3 from '../../images/TABLE-TENNIES.webp'
import pic4 from '../../images/Tennis-Area-Cam.webp'
import pic5 from '../../images/View_site.webp'
import pic6 from '../../images/Kids-room.webp'
import bg from '../../images/Living.webp'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { useMediaQuery } from 'react-responsive';
import { FaYoutube } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import ContactModal from './ContactModal';
import { setToggleTrue } from '../../redux/slice/changeState'
import { useDispatch, useSelector } from 'react-redux';

const Living = () => {
    const dispatch = useDispatch()
    const toggle = useSelector((state) => state.toggle);
    const imgData = [pic2, pic3, pic4, pic5, pic6];
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    const [show, setShow] = useState(false);
    return (
        <div className='living-section' style={{ backgroundImage: `url(${bg})` }}>
            <Container fluid className='living-room-cont'>
                <Row>
                    <Col lg={6} md={6} xs={12} className='d-flex align-items-center' style={{ paddingLeft: isMobile ? '' : '10%' }}>
                        <div style={{ padding: isMobile ? '12% 0% 9% 10%' : '' }}>
                            <img src={pic1} alt="" />
                            <div className='mt-2'>
                                <h1 >See IRA Aspiration</h1>
                                <h1>Come to Life</h1>
                            </div>
                            <h6 className='mb-3'>Step Inside Your Future Home</h6>
                            <div className={`${isMobile ? '' : 'd-flex align-items-between justify-content-between'}`}>
                                <button className={` ${isMobile ? 'mb-3 mt-3' : 'mt-3'} btn1`} onClick={() => dispatch(setToggleTrue())}>Book a site visit</button>
                                <button className={` ${isMobile ? 'mb-3' : 'mt-3'} btn2`}><a href='https://wa.api-whatsapp.in/ehbv4C' target="_blank" rel="noreferrer" className='text-decoration-none text-[#1E1E1E]'>Chat on WhatsApp</a></button>
                                {/* <button className='avail2'>Explore in 360°</button> */}
                            </div>
                            <div className={`${isMobile ? '' : 'd-flex align-items-between justify-content-between'}`} >


                                <button className={` ${isMobile ? 'mb-3' : 'mt-3'} btn3 d-flex align-items-center justify-content-center gap-2`} onClick={() => setShow(true)}><FaYoutube size={isMobile ? 16 : 30} /> Watch Video</button>
                                {/* <button className='avail2'>Explore in 360°</button> */}
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} xs={12}>
                        <div className="custom-gallery">

                            <div className="gallery-col first-col">
                                <img src="/living1.png" className="w-100 gallery-img" alt="" />
                                <img src="/living2.png" className="w-100 gallery-top-radius" alt="" />
                            </div>

                            <div className="gallery-col second-col">
                                <img src="/living3.png" className="w-100 gallery-bottom-radius" alt="" />
                                <img src="/living4.png" className="w-100 gallery-img" alt="" />
                            </div>

                            <div className="gallery-col third-col">
                                <img src="/living5.png" className="w-100 gallery-left-radius" alt="" />
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                size="lg"
                backdropClassName="contact-modal-backdrop"
            // backdropClassName="custom-backdrop"
            >
                <Modal.Body className="p-0">
                    <div className="ratio ratio-16x9">
                        <iframe
                            src="https://www.youtube.com/embed/27yyiWf9h8w?autoplay=1"
                            title="YouTube video"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Modal.Body>
            </Modal>
            {
                toggle.hastoggle && <ContactModal />
            }
        </div>
    )
}

export default Living
